import { render } from "./IndexView.vue?vue&type=template&id=592c2182&scoped=true&ts=true"
import script from "./IndexView.vue?vue&type=script&lang=ts"
export * from "./IndexView.vue?vue&type=script&lang=ts"

import "./IndexView.vue?vue&type=style&index=0&id=592c2182&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592c2182"]])

export default __exports__